import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { createSquadInput } from '@sorare/core/src/__generated__/globalTypes';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  CreateSquadMutation,
  CreateSquadMutationVariables,
} from './__generated__/useCreateSquad.graphql.ts';

const CREATE_SQUAD_MUTATION = gql`
  mutation CreateSquadMutation($input: createSquadInput!, $sport: Sport!) {
    createSquad(input: $input) {
      currentUser {
        slug
        squad(sport: $sport) {
          id
          joinSecret
        }
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<CreateSquadMutation, CreateSquadMutationVariables>;

export const useCreateSquad = () => {
  const [mutate, { loading }] = useMutation(CREATE_SQUAD_MUTATION, {
    showErrorsWithSnackNotification: true,
  });

  const createSquad = async (input: createSquadInput) => {
    const result = await mutate({ variables: { input, sport: input.sport } });
    return result.data;
  };

  return { createSquad, loading };
};
